const NewZealandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112004)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.9525 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3107 20H19.9466C19.9644 19.9822 19.9823 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38957 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M19.9992 17.5403L12.8935 10.4346C12.8935 10.4346 10.4341 10.4347 10.4341 10.4346V10.4347L19.9992 19.9997H19.9992C19.9992 19.9997 19.9992 18.3039 19.9992 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M34.6349 14.8398L35.0665 16.1684H36.4635L35.3333 16.9895L35.7651 18.318L34.6349 17.497L33.5047 18.318L33.9364 16.9895L32.8062 16.1684H34.2031L34.6349 14.8398Z"
        fill="#D80027"
      />
      <path
        d="M29.6409 24.4053L30.2885 26.3982H32.3839L30.6886 27.6298L31.3362 29.6227L29.6409 28.3911L27.9456 29.6227L28.5933 27.6298L26.8979 26.3982H28.9933L29.6409 24.4053Z"
        fill="#D80027"
      />
      <path
        d="M29.8292 8.75391L30.3688 10.4148H32.115L30.7022 11.4409L31.2419 13.1017L29.8292 12.0752L28.4165 13.1017L28.9561 11.4409L27.5435 10.4148H29.2896L29.8292 8.75391Z"
        fill="#D80027"
      />
      <path
        d="M25.0247 14.7832L25.6722 16.7762H27.7677L26.0724 18.0077L26.72 20.0006L25.0247 18.769L23.3294 20.0006L23.977 18.0077L22.2817 16.7762H24.3771L25.0247 14.7832Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112004">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NewZealandSvg;
